import React, {useState} from 'react';

const InputText = (props) => {

    const [state, setState] = useState({active: false});

    const onClickHandler = () => {
        setState({active: true});
    };

    const onBlurHandler = (fieldVal) => {
        if(!fieldVal) {
            setState({active: false});
        }
    }

    return (
        <div className={`inputText  ${ state.active ? 'active' : '' }`} onFocus={e => onClickHandler(props.id)} onClick={e => onClickHandler(props.id)}>
            {props.label &&
            <div className="labelContainer">
                <label id="" htmlFor="">{props.label}</label>
            </div>
            }
            <div className="input_outerContainer boxShadow">
                <div className="input_formWrapper">
                    <div className="" role="group" aria-labelledby="P6_TITLE_LABEL">
                        <input
                            type={props.type}
                            name={props.name}
                            value={props.value}
                            className={props.class}
                            tabIndex={props.tabIndex}
                            onChange={props.onChange}
                            onBlur={e => onBlurHandler(props.value)}
                        ></input>

                        {props.buttonName &&
                        <button type="button" className="a-Button a-Button--popupLOV" id="P6_TITLE_lov_btn">
                                <span className="a-Icon icon-popup-lov">
                                    <span className="visuallyhidden">Popup List of Values: Title</span>
                                </span>
                        </button>
                        }
                    </div>
                </div>
            </div>
            {props.required &&
            <span className="required">Required</span>
            }
            {props.error &&
            <span className="input_errorContainer"></span>
            }
        </div>
    )
};

export default InputText;